import { DetailsList } from 'components/DetailsList/DetailsList';
import { DetailsListItem } from 'components/DetailsList/Item/DetailsListItem';
import { INTERNSHIP_PAYMENT_TYPE } from 'utils/constants/general/internshipPaymentType';
import { humanDate } from 'utils/date';

type Props = {
  academicCredits: boolean | null;
  applicationDeadline: string | null;
  endDate: string | null;
  hoursPerWeek: number | null;
  payment: string | null;
  startDate: string | null;
  wage: string | null;
};

export function InternshipDetailsList({
  academicCredits,
  applicationDeadline,
  endDate,
  hoursPerWeek,
  payment,
  startDate,
  wage,
}: Props) {
  return (
    <DetailsList>
      {startDate && (
        <DetailsListItem
          title={getText('Start Date')}
          iconName="calendar"
          value={humanDate(startDate)}
        />
      )}

      {endDate && (
        <DetailsListItem
          title={getText('End Date')}
          iconName="calendar"
          value={humanDate(endDate)}
        />
      )}

      {applicationDeadline && (
        <DetailsListItem
          title={getText('Application Deadline')}
          iconName="hourglass"
          value={humanDate(applicationDeadline)}
        />
      )}

      {academicCredits && (
        <DetailsListItem
          title={getText('Internship Benefits')}
          iconName="academic-credits"
          value={getText('Academic Credits')}
        />
      )}

      {payment && (
        <DetailsListItem
          title={getText('Payment')}
          iconName="coin"
          value={
            INTERNSHIP_PAYMENT_TYPE[
              // TODO: refactor to get rid of typecasting
              payment as keyof typeof INTERNSHIP_PAYMENT_TYPE
            ]
          }
        />
      )}

      {wage && (
        <DetailsListItem
          title={getText('Stipend / Wage')}
          iconName="coin"
          value={wage}
        />
      )}

      {hoursPerWeek && (
        <DetailsListItem
          title={getText('Hours Per Week')}
          iconName="hourglass"
          value={hoursPerWeek}
        />
      )}
    </DetailsList>
  );
}
